//import { useState } from 'react';

function Footer() {
 
  return (
    <footer className="footer">
        <p>&copy; 2021</p>
        <p>Powered by <a href="https://rschemes.netlify.app">Schemes</a> </p>
    </footer>
  );
}

export default Footer;